export class BeanMonitoryExclusion {
    constructor(
    public exmoIdCdExclusaoMonitoria:  number,
    public exmoDsMotivo: string,
    public exmoDsStatus: string,
    public usuaIdCdUsuario: number,
    public usuaIdCdUsuarioAprovacao: number,
    public exmoDhAprovacao: string,
    public moniIdCdMonitoria: number,
    public operNmOperacao: string,
    public formDsFormulario: string,
    public usuaNmUsuario: string
    ){} 
}